
import {City} from './city';
import {Country} from './country';

export type AirportRouteRole = 'departure' | 'transit' | 'arrival';

export type Translations = Record<string, string>;

export class Airport {
  id?: number;
  slug: string = '';
  name: string = '';
  iata_code?: string | null;
  icao_code?: string | null;
  faa_code?: string | null;
  un_locode?: string | null;
  timezone: string = '';
  lat: number = 0;
  lng: number = 0;
  alt?: number | null;
  city_code?: string | null;
  city?: string | null;
  cityObject?: City | null;
  countryObject?: Country | null;
  country_code: string = '';
  departures_intl?: number | null;
  departures_dom?: number | null;
  connections_intl?: number | null;
  connections_dom?: number | null;
  is_major?: string | null;
  is_international?: string | null;
  runways?: string | null;
  connections?: number | null;
  departures?: number | null;
  website?: string | null;
  twitter?: string | null;
  facebook?: string | null;
  instagram?: string | null;
  linkedin?: string | null;
  youtube?: string | null;
  phone?: string | null;
  phone_formatted?: string | null;
  email?: string | null;
  postal_code?: string | null;
  with_schedules?: string | null;
  type?: string | null;
  fir_code?: string | null;
  fir_name?: string | null;
  size?: string | null;
  popularity: number = 0;
  names?: Translations | null;
  createdBy?: number;
  createdDate?: string;
  updatedBy?: number;
  updatedDate?: string;
  active: boolean = false;

  routeRole?: AirportRouteRole;
  routeOrder: number = 0;

  constructor(value?: Airport) {
    this.id = value?.id;
    this.slug = value?.slug ?? '';
    this.name = value?.name ?? '';
    this.iata_code = value?.iata_code ?? null;
    this.icao_code = value?.icao_code ?? null;
    this.faa_code = value?.faa_code ?? null;
    this.un_locode = value?.un_locode ?? null;
    this.timezone = value?.timezone ?? '';
    this.lat = value?.lat ?? 0;
    this.lng = value?.lng ?? 0;
    this.alt = value?.alt;
    this.city_code = value?.city_code ?? null;
    this.city = value?.city ?? null;
    this.cityObject = value?.cityObject ?? null;
    this.countryObject = value?.countryObject ?? null;
    this.country_code = value?.country_code ?? '';
    this.departures_intl = value?.departures_intl ?? null;
    this.departures_dom = value?.departures_dom ?? null;
    this.connections_intl = value?.connections_intl ?? null;
    this.connections_dom = value?.connections_dom ?? null;
    this.is_major = value?.is_major ?? null;
    this.is_international = value?.is_international ?? null;
    this.runways = value?.runways ?? null;
    this.connections = value?.connections ?? null;
    this.departures = value?.departures ?? null;
    this.website = value?.website ?? null;
    this.twitter = value?.twitter ?? null;
    this.facebook = value?.facebook ?? null;
    this.instagram = value?.instagram ?? null;
    this.linkedin = value?.linkedin ?? null;
    this.youtube = value?.youtube ?? null;
    this.phone = value?.phone ?? null;
    this.phone_formatted = value?.phone_formatted ?? null;
    this.email = value?.email ?? null;
    this.postal_code = value?.postal_code ?? null;
    this.with_schedules = value?.with_schedules ?? null;
    this.type = value?.type ?? null;
    this.fir_code = value?.fir_code ?? null;
    this.fir_name = value?.fir_name ?? null;
    this.size = value?.size ?? null;
    this.popularity = value?.popularity ?? 0;
    this.names = value?.names ?? null;
    this.createdBy = value?.createdBy;
    this.createdDate = value?.createdDate;
    this.updatedBy = value?.updatedBy;
    this.updatedDate = value?.updatedDate;
    this.active = value?.active ?? false;

    this.routeRole = value?.routeRole;
    this.routeOrder = value?.routeOrder ?? 0;
  }
}
